import { render, staticRenderFns } from "./step-button.vue?vue&type=template&id=aba31906"
import script from "./step-button.vue?vue&type=script&lang=js"
export * from "./step-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports